// extracted by mini-css-extract-plugin
export var card = "_b2-c";
export var checkmark = "_b2-k";
export var childrenContainer = "_b2-6";
export var container = "_b2-b";
export var disabled = "_b2-9";
export var disabledChildren = "_b2-a";
export var focused = "_b2-1";
export var gray = "_b2-s";
export var green = "_b2-p";
export var icon = "_b2-g";
export var iconWrapper = "_b2-8";
export var imageCircle = "_b2-u";
export var large = "_b2-5";
export var lg = "_b2-j";
export var listItemContainer = "_b2-0";
export var md = "_b2-i";
export var medium = "_b2-4";
export var menu = "_b2-f";
export var nonInteractiveBadge = "_b2-m";
export var red = "_b2-q";
export var rightArea = "_b2-7";
export var sectionContainer = "_b2-e _b2-b";
export var selected = "_b2-d";
export var sm = "_b2-h";
export var small = "_b2-3";
export var statusDot = "_b2-o";
export var statusDotContainer = "_b2-n";
export var text = "_b2-l";
export var transparent = "_b2-t";
export var xs = "_b2-2";
export var yellow = "_b2-r";